module.exports = __webpack_public_path__ + "img/two-way-arrows.255d645d.svg";